import kutil from "./kutil";


export interface Code {
  code: string;
  value: string;
}

export type Codes = {
  [key: string]: Code[];
}

let isInitialized: boolean = false;

async function reloadCommonCodes() {
  if (isInitialized) {
    return;
  }
  await initCommonCodes();
}

async function initCommonCodes() {
  try {
    isInitialized = true;
    const data = await kutil.sendGet("/api/common/commonCode.data?mode=search", {}, {skipLoading: true});
    Object.keys(data).forEach(codeType => {
      const codes: any[] = data[codeType];
      (commonCode as Codes)[codeType + ".all"] = codes;
      (commonCode as Codes)[codeType] = codes.filter(code => code.useYn == "Y");
    });
    return true;
  } catch(e) {
    console.log(e);
    isInitialized = false;
    return false;
  }
}

function getCodeValue(codeTypeOrCodes: string| Code[], code: string) {
  let infos: Code[] = [];
  if (typeof codeTypeOrCodes == "string") {
    infos = (commonCode as Codes)[codeTypeOrCodes + ".all"] as Code[];
  } else {
    infos = codeTypeOrCodes;
  }
  if (infos.length == 0) {
    return code;
  }
  for(let i=0; i<infos.length; ++i) {
    const info = infos[i];
    if (info.code == code) {
      return info.value;
    }
  }
  return code;
}

type CommonCode = Codes & {
  isInitialized: boolean;
  reloadCommonCodes: () => Promise<void>;
  initCommonCodes: () => Promise<boolean>;
  getCodeValue: (codeTypeOrCodes: string| Code[], code: string) => string;
};

const commonCode: CommonCode = {
  isInitialized,
  reloadCommonCodes,
  initCommonCodes,
  getCodeValue
} as any;

export default commonCode;
